import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserStore } from '../stores/user.store';

// prevent access to /auth if user is already loggedIn
export const loggedOutGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isLoggedIn()) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
